import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import BridgeOfficer from "./BridgeOfficer";

const style = {
    bridgeOfficer: {
        height: "48px",
        width: "32px",
    },
    selector: {
        // position: absolute;
        // inset: 0px auto auto 0px;
        transform: "translate(-10px, 50px)",
        zIndex: "10",
    },
};

function BridgeOfficerSelector({ data, setData, index }) {
    const [tab, setTab] = useState("profession");
    const [showSelector, setShowSelector] = useState(false);
    const ref = useRef(null);

    let bridgeOfficer = data.bridge_officers[index];
    let ranks = { 1: "ens", 2: "lt", 3: "ltcmdr", 4: "cmdr" };
    let professions = { 1: "univ", 2: "eng", 3: "sci", 4: "tac" };
    let specializations = {
        2: "int",
        3: "pilot",
        5: "cmd",
        6: "temporaloperative",
        8: "miracle",
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowSelector(false);
            }
        };

        document.addEventListener("click", handleClickOutside, true);

        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    const handleChange = (property, index, event) => {
        let newData = { ...data };

        if(newData.start) {
            delete newData.start;
        }

        newData.bridge_officers[index] = {
            ...data.bridge_officers[index],
            [property]: event.target.value,
        };

        setData(newData);
    };

    const removeBridgeOfficer = (e, index) => {
        e.preventDefault();
        
        let newData = { ...data };

        if(newData.start) { delete newData.start; }
        
        newData.bridge_officers.splice(index, 1);
        setData(newData);
    };

    const imageSelector = (rank, profession, specialization) => {
        let urlParts = [];
        let fileParts = [];

        urlParts.push(process.env.PUBLIC_URL);
        urlParts.push("img");
        urlParts.push("boff");
        fileParts.push("Boff");

        fileParts.push(rank ? ranks[rank] : "rankless");
        fileParts.push(profession ? professions[profession] : "unemployed");

        if (specialization) {
            fileParts.push(specializations[specialization]);
        }

        urlParts.push(fileParts.join("_") + ".png");

        return urlParts.join("/");
    };

    return (
        <>
            <BridgeOfficer
                className="d-inline-block border border-secondary rounded p-1"
                bridgeOfficer={bridgeOfficer}
                onClick={() => setShowSelector((b) => !b)}
            />

            {showSelector && (
                <div
                    ref={ref}
                    className="position-absolute bg-dark bridge-officer-selector rounded border border-primary m-2 float-start shadow"
                    style={style.selector}
                    role="tablist"
                    aria-label="Bridge Officer Selector"
                >
                    {tab === "rank" && (
                        <div
                            className="p-2"
                            onChange={(e) => handleChange("rank", index, e)}
                            role="tabpanel"
                        >
                            <input
                                className="d-none"
                                type="radio"
                                id={"rankless" + index}
                                name={"rank" + index}
                                value=""
                                defaultChecked={
                                    !data.bridge_officers[index].rank
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"rankless" + index}
                                title="Any Rank"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        null,
                                        bridgeOfficer.profession,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Any Rank"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"ens" + index}
                                name={"rank" + index}
                                value={1}
                                defaultChecked={
                                    data.bridge_officers[index].rank === 1
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"ens" + index}
                                title="Ensign"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        1,
                                        bridgeOfficer.profession,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Ensign"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"lt" + index}
                                name={"rank" + index}
                                value={2}
                                defaultChecked={
                                    data.bridge_officers[index].rank === 2
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"lt" + index}
                                title="Lieutenant"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        2,
                                        bridgeOfficer.profession,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Lieutenant"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"ltcmdr" + index}
                                name={"rank" + index}
                                value={3}
                                defaultChecked={
                                    data.bridge_officers[index].rank === 3
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"ltcmdr" + index}
                                title="Lt. Commander"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        3,
                                        bridgeOfficer.profession,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Lt. Commander"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"cmdr" + index}
                                name={"rank" + index}
                                value={4}
                                defaultChecked={
                                    data.bridge_officers[index].rank === 4
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"cmdr" + index}
                                title="Commander"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        4,
                                        bridgeOfficer.profession,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Commander"
                                />
                            </label>
                        </div>
                    )}
                    {tab === "profession" && (
                        <div
                            className="p-2"
                            onChange={(e) =>
                                handleChange("profession", index, e)
                            }
                            role="tabpanel"
                        >
                            <input
                                className="d-none"
                                type="radio"
                                id={"unemployed" + index}
                                name={"profession" + index}
                                value=""
                                defaultChecked={
                                    !data.bridge_officers[index].profession
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"unemployed" + index}
                                title="Any Class"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        null,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Any Class"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"univ" + index}
                                name={"profession" + index}
                                value={1}
                                defaultChecked={
                                    data.bridge_officers[index].profession === 1
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"univ" + index}
                                title="Univeral"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        1,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Universal"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"eng" + index}
                                name={"profession" + index}
                                value={2}
                                defaultChecked={
                                    data.bridge_officers[index].profession === 2
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"eng" + index}
                                title="Engineering"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        2,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Engineering"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"sci" + index}
                                name={"profession" + index}
                                value={3}
                                defaultChecked={
                                    data.bridge_officers[index].profession === 3
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"sci" + index}
                                title="Science"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        3,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Science"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"tac" + index}
                                name={"profession" + index}
                                value={4}
                                defaultChecked={
                                    data.bridge_officers[index].profession === 4
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"tac" + index}
                                title="Tactical"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        4,
                                        bridgeOfficer.specialization
                                    )}
                                    alt="Tactical"
                                />
                            </label>
                        </div>
                    )}

                    {tab === "specialization" && (
                        <div
                            className="p-2"
                            onChange={(e) =>
                                handleChange("specialization", index, e)
                            }
                            role="tabpanel"
                        >
                            <input
                                className="d-none"
                                type="radio"
                                id={"unemployed" + index}
                                name={"specialization" + index}
                                value=""
                                defaultChecked={
                                    !data.bridge_officers[index].specialization
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"unemployed" + index}
                                title="No Specialization"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        bridgeOfficer.profession,
                                        null
                                    )}
                                    alt="No Specialization"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"int" + index}
                                name={"specialization" + index}
                                value={2}
                                defaultChecked={
                                    data.bridge_officers[index]
                                        .specialization === 2
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"int" + index}
                                title="Intelligence Officer"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        bridgeOfficer.profession,
                                        2
                                    )}
                                    alt="Intelligence Officer"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"pilot" + index}
                                name={"specialization" + index}
                                value={3}
                                defaultChecked={
                                    data.bridge_officers[index]
                                        .specialization === 3
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"pilot" + index}
                                title="Pilot"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        bridgeOfficer.profession,
                                        3
                                    )}
                                    alt="Pilot"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"cmd" + index}
                                name={"specialization" + index}
                                value={5}
                                defaultChecked={
                                    data.bridge_officers[index]
                                        .specialization === 5
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"cmd" + index}
                                title="Command Officer"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        bridgeOfficer.profession,
                                        5
                                    )}
                                    alt="Command Officer"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"temporaloperative" + index}
                                name={"specialization" + index}
                                value={6}
                                defaultChecked={
                                    data.bridge_officers[index]
                                        .specialization === 6
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"temporaloperative" + index}
                                title="Temporal Operative"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        bridgeOfficer.profession,
                                        6
                                    )}
                                    alt="Temporal Operative"
                                />
                            </label>

                            <input
                                className="d-none"
                                type="radio"
                                id={"miracle" + index}
                                name={"specialization" + index}
                                value={8}
                                defaultChecked={
                                    data.bridge_officers[index]
                                        .specialization === 8
                                }
                            />
                            <label
                                className="p-2 rounded"
                                htmlFor={"miracle" + index}
                                title="Miracle Worker"
                            >
                                <img
                                    style={style.bridgeOfficer}
                                    src={imageSelector(
                                        bridgeOfficer.rank,
                                        bridgeOfficer.profession,
                                        8
                                    )}
                                    alt="Miracle Worker"
                                />
                            </label>
                        </div>
                    )}

                    <div
                        className="d-flex border-top border-primary"
                        role="tablist"
                    >
                        <div
                            className={`p-2 border-end border-primary flex-fill text-center ${
                                tab === "profession"
                                    ? "bg-primary text-white"
                                    : ""
                            }`}
                            onClick={(e) => setTab("profession")}
                            style={{ borderBottomLeftRadius: "0.25rem" }}
                            role="tab"
                            aria-selected={tab === "profession"}
                        >
                            Class
                        </div>
                        <div
                            className={`p-2 border-end border-primary flex-fill text-center ${
                                tab === "rank" ? "bg-primary text-white" : ""
                            }`}
                            onClick={(e) => setTab("rank")}
                            role="tab"
                            aria-selected={tab === "rank"}
                        >
                            Rank
                        </div>
                        <div
                            className={`p-2 flex-fill text-center border-end border-primary ${
                                tab === "specialization"
                                    ? "bg-primary text-white"
                                    : ""
                            }`}
                            onClick={(e) => setTab("specialization")}
                            role="tab"
                            aria-selected={tab === "specialization"}
                        >
                            Specialization
                        </div>
                        <div
                            className="p-2 flex-fill text-center"
                            style={{ borderBottomRightRadius: "0.25rem" }}
                            onClick={(e) => removeBridgeOfficer(e, index)}
                            role="button"
                        >
                            <svg
                                height="1rem"
                                style={{
                                    marginBottom: "3px",
                                    fill: "var(--bs-red)",
                                }}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                            >
                                <path d="M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM31.1 128H416V448C416 483.3 387.3 512 352 512H95.1C60.65 512 31.1 483.3 31.1 448V128zM111.1 208V432C111.1 440.8 119.2 448 127.1 448C136.8 448 143.1 440.8 143.1 432V208C143.1 199.2 136.8 192 127.1 192C119.2 192 111.1 199.2 111.1 208zM207.1 208V432C207.1 440.8 215.2 448 223.1 448C232.8 448 240 440.8 240 432V208C240 199.2 232.8 192 223.1 192C215.2 192 207.1 199.2 207.1 208zM304 208V432C304 440.8 311.2 448 320 448C328.8 448 336 440.8 336 432V208C336 199.2 328.8 192 320 192C311.2 192 304 199.2 304 208z" />
                            </svg>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default BridgeOfficerSelector;
